import React, { useContext, useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { COVID_TESTING_ANCHOR, CovidTestSlugs } from './util';
import CovidTestAccordion from './components/CovidTestAccordion';
import {
  containsCovidNewService,
  findIndexCovidTestType,
  hasCovidTest,
  hasCovidTestType,
  isCovidTestingV2,
} from '../../../../core/util/location';
import { LocationContext } from '../../ContextProviders';
import { AnchorTag } from './CSSstyles';

type CovidTestServiceDataStruct = {
  price?: string;
  min_price?: string;
  max_price?: string;
  notes?: string;
  details?: {
    walkins_accepted?: boolean;
    accept_insurance?: boolean;
    accept_cash?: boolean;
    has_price_range?: boolean;
    time_to_result?: string;
    requirements?: any[];
    location_performing?: any[];
    sample_analysis?: {
      in_house?: { result_time: string };
      send_out?: { result_time: string };
    };
  };
  slug: string;
};

const getCovidTestServiceData = (servicesObj: any, testType: string, version?: string) => {
  if (!hasCovidTestType(servicesObj, testType)) return {};
  const index = findIndexCovidTestType(servicesObj, testType);
  const data: CovidTestServiceDataStruct = servicesObj['Labs and Tests'][index];

  if (!data) return {};
  if (version === 'V1') {
    return {
      locationPerforming: data.details?.location_performing || [],
      requirements: data.details?.requirements || [],
      sampleAnalysis: data.details?.sample_analysis || {},
      type: data.slug,
    };
  }
  return {
    screeningRequired: data.details?.requirements && data.details.requirements.length > 0,
    walkinAccepted: !!data.details?.walkins_accepted,
    insuranceAccepted: !!data.details?.accept_insurance,
    cashAccepted: !!data.details?.accept_cash,
    price: data.price,
    minPrice: data.min_price,
    maxPrice: data.max_price,
    hasPriceRange: data.details?.has_price_range,
    timeToResult: data.details?.time_to_result,
    notes: data.notes,
    type: data.slug,
  };
};

const CovidTesting = () => {
  const { location } = useContext(LocationContext);
  const { servicesObj, displayNamePrimary, displayNameSecondary } = location;
  const [rapidAntigenObj, setRapidAntigenObj] = useState({});
  const [antigenObj, setAntigenObj] = useState({});
  const [rapidPCRObj, setRapidPCRObj] = useState({});
  const [PCRObj, setPCRObj] = useState({});
  const [antibodyObj, setAntibodyObj] = useState({});
  const [covidObj, setCovidObj] = useState({});

  useEffect(() => {
    if (servicesObj) {
      setRapidAntigenObj(
        getCovidTestServiceData(servicesObj, CovidTestSlugs.COVID_RAPID_ANTIGEN_TEST)
      );
      setAntigenObj(getCovidTestServiceData(servicesObj, CovidTestSlugs.COVID_ANTIGEN_TEST));
      setRapidPCRObj(getCovidTestServiceData(servicesObj, CovidTestSlugs.COVID_RAPID_PCR_TEST));
      setPCRObj(getCovidTestServiceData(servicesObj, CovidTestSlugs.COVID_PCR_TEST));
      setAntibodyObj(getCovidTestServiceData(servicesObj, CovidTestSlugs.ANTIBODY));
      setCovidObj(getCovidTestServiceData(servicesObj, CovidTestSlugs.COVID_TEST, 'V1'));
    }
  }, [servicesObj]);

  // Only if the current location has one of these five tests or the old covid test, the session will get rendered
  if (!isCovidTestingV2(location) && !hasCovidTest(servicesObj)) return null;

  return (
    <>
      {/* TODO: why do we need this ts-error for testing anchor? */}

      {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'name' does not exist on type 'IntrinsicA... Remove this comment to see the full error message */}
      <AnchorTag id={COVID_TESTING_ANCHOR} name={COVID_TESTING_ANCHOR} />

      {!isEmpty(rapidAntigenObj) && <CovidTestAccordion data={rapidAntigenObj} />}
      {!isEmpty(antigenObj) && <CovidTestAccordion data={antigenObj} />}
      {!isEmpty(rapidPCRObj) && <CovidTestAccordion data={rapidPCRObj} />}
      {!isEmpty(PCRObj) && <CovidTestAccordion data={PCRObj} />}
      {!isEmpty(antibodyObj) && <CovidTestAccordion data={antibodyObj} />}
      {!isEmpty(covidObj) && !containsCovidNewService(location) && (
        <CovidTestAccordion data={covidObj} />
      )}
    </>
  );
};

export default React.memo(CovidTesting);
